export const Container = ({ isDark, className, children }) => {
  return (
    <section
      className={['container', isDark && 'has-dark-background', className]
        .filter(Boolean)
        .join(' ')}
    >
      {children}
    </section>
  );
};
